<template>
  <v-container>
    <v-tabs v-model="tab">
      <v-tabs-slider></v-tabs-slider>
      <v-tab>Ordini Periodici
      </v-tab>
      <v-tab>Import Aggiornamento
      </v-tab>
      <v-tab>Import Barcode Aggiornati
      </v-tab>      
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <ordini-periodici />
      </v-tab-item>
      <v-tab-item>
        <import-aggiornamento />
      </v-tab-item>
      <v-tab-item>
        <import-barcode-aggiornati />
      </v-tab-item>      
    </v-tabs-items>
  </v-container>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import OrdiniPeriodici from './ordiniPeriodici'
  import ImportAggiornamento from './importAggiornamento'
  import ImportBarcodeAggiornati from './importBarcodeAggiornati'

  export default {
    components: {
      OrdiniPeriodici,
      ImportAggiornamento,
      ImportBarcodeAggiornati
    },
    mixins: [verificaLicenza],
    data() {
      return {
        tab: null
      }
    },
    async mounted() {
      await this.verificaModuliLocali()
    }
  }
</script>
